<template>
  <div class="internal-parts-listing">
    <v-layout class="p-2 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex class="d-flex font-level-3-bold my-auto">
        <span class="form-title font-size-20"> Available </span>
      </v-flex>
      <v-flex
        class="d-flex font-level-3-bold my-auto"
        style="justify-content: end"
      >
        <v-select
          v-model="filterType"
          :items="filterOptions"
          item-text="text"
          item-value="value"
          hide-details
          item-color="cyan"
          :disabled="pageLoading"
          style="max-width: 160px"
          dense
          filled
          color="cyan"
          solo
        ></v-select>
        <v-btn
          :disabled="pageLoading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          depressed
          @click="openSerialNumberDialog(productInfo.isSerialized)"
        >
          <v-icon size="20">mdi-plus</v-icon>
          Add
        </v-btn>
      </v-flex>
    </v-layout>

    <v-simple-table fixed-header height="67vh" class="w-100">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="simple-table-th">Type</th>
            <th class="simple-table-th">Quantity</th>
            <th class="simple-table-th">Related #</th>
            <th class="simple-table-th">Date</th>
            <th class="simple-table-th">Inbound Date</th>
            <th class="simple-table-th">Remarks</th>
            <th class="simple-table-th">Created Time</th>
            <th class="simple-table-th">Action</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="inventoryData.length > 0">
            <tr
              v-for="(row, index) in inventoryData"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <!-- <td class="simple-table-td">
                {{ index + 1 }}
              </td> -->
              <td class="simple-table-td pl-4 text-capitalize">
                {{ row.type }}
              </td>

              <td class="simple-table-td pl-4">
                <template v-if="row.quantity">
                  {{ row.quantity }}
                </template>
                <template v-else>
                  <em class="text-muted">no quantity</em>
                </template>
              </td>

              <td class="simple-table-td pl-4">
                <template v-if="row.related_barcode">
                  {{ row.related_barcode }}
                </template>
                <template v-else>
                  <em class="text-muted">no barcode</em>
                </template>
              </td>

              <td class="simple-table-td pl-4">
                <template v-if="row.date">
                  {{ row.date }}
                </template>
                <template v-else>
                  <em class="text-muted">no date</em>
                </template>
              </td>

              <td class="simple-table-td pl-4">
                <template v-if="row.inbound_date">
                  {{ row.inbound_date }}
                </template>
                <template v-else>
                  <em class="text-muted">no inbound date</em>
                </template>
              </td>

              <td
                class="simple-table-td pl-4"
                style="
                  max-width: 150px;
                  white-space: normal;
                  word-break: break-word;
                  overflow-wrap: anywhere;
                "
              >
                <template v-if="row.remarks">
                  {{ row.remarks }}
                </template>
                <template v-else>
                  <em class="text-muted">no remarks</em>
                </template>
              </td>

              <td class="simple-table-td pl-4">
                <TableActivity :data="row" v-if="row && row.added_by">
                  <template v-slot:display_name>
                    {{ row.added_by.display_name }}
                  </template>

                  <template v-slot:date_time>
                    <template v-if="getDateCountAll(row.added_at)"
                      >{{ formatDateTime(row.added_at) }}
                    </template>
                    <template v-else
                      >{{ formatDateTime(row.added_at) }}
                    </template>
                  </template>
                  <template v-slot:format_date_time>
                    {{ formatDate(row.added_at) }}
                    {{ formatTime(row.added_at) }}
                  </template>
                </TableActivity>
              </td>
              <td class="simple-table-td pl-4" v-if="row.type == 'inbond' && row.related_type == 'product'">
                <v-icon
                  small
                  class="mr-2"
                  color="cyan"
                  v-on:click="editInventory(row)"
                  >mdi-pencil</v-icon
                >
                <v-icon
                  small
                  color="red lighten-1"
                  v-on:click="deleteInventoryRow(row)"
                  >mdi-delete</v-icon
                >
              </td>
              <td class="simple-table-td pl-4" v-else></td>
            </tr>
          </template>
          <template v-else>
            <template v-if="pageLoading">
              <tr v-for="row in 3" :key="row">
                <!-- <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td> -->
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
              </tr>
            </template>
            <tr v-else-if="!pageLoading">
              <td colspan="7">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no inventory at present.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <ListingFooter
      :dataLoading="pageLoading"
      :currentPage="current_page"
      :totalPages="total_pages"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="total_rows"
      removePage
    ></ListingFooter>
    <CreateOrUpdateSerialNo
      v-if="addInventoryDialog"
      :dialogStatus="addInventoryDialog"
      :productId="type_id"
      :serialized="Number(serialized)"
      :serialNumberDetail="selectedInventory"
      @close:dialog="closeSerialNumberDialog"
      @refresh:inventory="refreshInventory"
    ></CreateOrUpdateSerialNo>

    <DeleteDialog :delete-dialog="deleteInventoryDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3
          class="font-weight-500 delete-text"
          style="font-size: 20px !important"
        >
          Are you sure you want to delete this
          <span class="font-weight-700">{{ selectedDeleteRow?.type }}</span>
          entry
          <template v-if="selectedDeleteRow?.related_barcode">
            (<span class="font-weight-700">{{
              selectedDeleteRow.related_barcode
            }}</span
            >)
          </template>
          ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deleteInventoryLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteInventoryDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deleteInventoryLoading"
          :loading="deleteInventoryLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteInventoryConfirm()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>
  </div>
</template>

<script>
import { QUERY, DELETE } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import CreateOrUpdateSerialNo from "@/view/pages/partials/AddInventory";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import moment from "moment-timezone";
import DeleteDialog from "@/view/pages/partials/Delete";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      dates: [],
      addInventoryDialog: false,
      pageLoading: false,
      inventoryData: new Array(),
      filter: {
        search: null,
      },
      per_page: 15,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      serialized: 0,
      selectedInventory: {},
      deleteInventoryDialog: false,
      deleteInventoryLoading: false,
      selectedDeleteRow: {},
      filterType: "all",
      filterOptions: [
        { text: "All", value: "all" },
        { text: "Inbond", value: "inbond" },
        { text: "Outbond", value: "outbond" },
      ],
    };
  },
  components: {
    ListingFooter,
    CreateOrUpdateSerialNo,
    TableActivity,
    DeleteDialog,
  },
  props: {
    type: {
      required: true,
      type: String,
      default: "",
    },
    productInfo: {
      required: true,
      type: Object,
      default: () => {},
    },
    type_id: {
      required: true,
      type: Number,
      default: 0,
    },
    inbondDate: {
      type: String,
      default: null,
    },
    inbondDoc: {
      type: String,
      default: null,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getProductInventory(type_id);
      }
    },
    filterType() {
      this.current_page = 1;
      this.getProductInventory(this.type_id);
    },
  },
  methods: {
    openSerialNumberDialog(serialized) {
      this.selectedInventory = {};
      this.serialized = serialized;
      this.addInventoryDialog = true;
    },
    closeSerialNumberDialog() {
      this.addInventoryDialog = false;
      this.selectedInventory = {};
    },
    editInventory(row) {
      this.selectedInventory = {
        id: row.id,
        product_id: this.type_id,
        initial_stock: row.quantity,
        purchase_date: row.date
          ? moment(row.date, "DD-MM-YYYY").format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        inbound_date: row.inbound_date
          ? moment(row.inbound_date, "DD-MM-YYYY").format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        inbound_doc: row.related_barcode,
        remarks: row.remarks,
      };
      console.log(this.selectedInventory);
      this.serialized = 0;
      this.addInventoryDialog = true;
    },
    refreshInventory() {
      this.getProductInventory(this.type_id);
    },
    getProductInventory(productId) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: `all-non-serial-number/${this.type}/${productId}`,
          data: {
            per_page: _this.per_page,
            current_page: _this.current_page,
            filter_type: _this.filterType,
          },
        })
        .then((data) => {
          this.inventoryData = data.data.rows;
          _this.offset = data.data.offset;
          _this.total_pages = Math.ceil(
            data.data.total_rows / data.data.per_page
          );
          _this.current_page = data.data.current_page;
          _this.total_rows = data.data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    deleteInventoryRow(row) {
      this.selectedDeleteRow = row;
      this.deleteInventoryDialog = true;
    },

    deleteInventoryConfirm() {
      const _this = this;
      _this.deleteInventoryLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url: `non-serial-item/${_this.selectedDeleteRow.id}`,
        })
        .then(() => {
          _this.deleteInventoryDialog = false;
          _this.selectedDeleteRow = {};
          _this.getProductInventory(_this.type_id);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.deleteInventoryLoading = false;
        });
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getProductInventory(type_id);
    }

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getProductInventory(_this.type_id);
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.inventoryData) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.inventoryData ? this.inventoryData.length : 0);
    },
  },
};
</script>
